<template>
    <div class="form-content-wrapper">
        <h6 class="form-title">KONDISI</h6>
        <div>
            <b-button variant="pgiBtn" name="kondisiAddBtn" @click="addKondisi"><i
                    class="fa fa-plus mr-2"></i>Kondisi</b-button>

            <b-table bordered hover show-empty :fields="fields" :busy="isBusy" class="mt-2" :items="kondisi" responsive>
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data.
                </template>
                <template v-slot:cell(klasifikasi)="row">
                    <div v-if="row.item.dus !== null">
                        <span v-if="row.item.dus">Dus</span>
                        <span v-else>Non Dus</span>
                    </div>
                    <div v-else>
                        <span v-if="row.item.namaSendiri">BPKB a/n Sendiri</span>
                        <span v-else>BPKB a/n Orang Lain</span>
                    </div>
                </template>
                <template v-slot:cell(hargaMaksimal)="row">
                    <div class="text-right no wrap" v-if="row.item.hargaMaksimal == null">
                        {{ $helper.addThousandSeparator(row.item.hargaMaksimal) }} </div>
                    <div class="text-right no wrap text-danger" v-else-if="row.item.hargaMaksimal < 0">Rp.
                        {{ $helper.addThousandSeparator(row.item.hargaMaksimal) }} </div>
                    <div class="text-right no wrap" v-else>Rp.
                        {{ $helper.addThousandSeparator(row.item.hargaMaksimal) }} </div>
                </template>
                <template v-slot:cell(nominalAngka)="row">
                    <div class="text-right no wrap" v-if="row.item.nominalAngka == null">
                        {{ $helper.addThousandSeparator(row.item.nominalAngka) }} </div>
                    <div class="text-right no wrap text-danger" v-else-if="row.item.nominalAngka < 0">Rp.
                        {{ $helper.addThousandSeparator(row.item.nominalAngka) }} </div>
                    <div class="text-right no wrap" v-else>Rp.
                        {{ $helper.addThousandSeparator(row.item.nominalAngka) }} </div>
                </template>
                <template v-slot:cell(nominalPersen)="row">
                    <div class="text-right no-wrap" v-if="row.item.nominalPersen == null">
                        {{ $helper.addThousandSeparator(row.item.nominalPersen) }} </div>
                    <div class="text-right no-wrap text-danger" v-else-if="row.item.nominalPersen < 100">
                        {{ $helper.addThousandSeparator(row.item.nominalPersen) }} %</div>
                    <div class="text-right no-wrap" v-else>{{ $helper.addThousandSeparator(row.item.nominalPersen)
                    }}
                        %</div>
                </template>
                <template v-slot:cell(aksi)="row">
                    <div class="d-flex">
                        <b-button size="sm" class="table-button edit mr-2" v-b-tooltip.hover title="Edit"
                            name="merkBarangEditBtn" @click="editKondisi(row.item)">
                            <i class="fa fa-pencil-square-o"></i>
                        </b-button>

                        <b-button class="btn btn-sm" variant="danger" @click="confirmDeleteKondisi(row.item.id)">
                            <i class="fa fa-trash"></i>
                        </b-button>
                    </div>

                </template>
            </b-table>
        </div>

        <b-modal id="modal-entri-kondisi" size="md" title="Kondisi">
            <label>Nama</label>
            <b-input-group class="mb-3">
                <b-form-input v-model="input.name" name="harga" required></b-form-input>
            </b-input-group>

            <b-form-group v-if="merkBarang && merkBarang.jenis.id != 13 && merkBarang && merkBarang.jenis.id != 14" label="Packing">
                <b-form-select v-model="input.dus" name="kondisiPacking" :options="kondisiOption" value-field="value"
                    text-field="name" required>
                </b-form-select>
            </b-form-group>
            <b-form-group v-else label="BPKB">
                <b-form-select v-model="input.namaSendiri" name="kondisiKendaraan" :options="kondisiKendaraan"
                    value-field="value" text-field="name" required>
                </b-form-select>
            </b-form-group>

            <b-row>
                <b-col md="4">
                    <b-form-group>
                        <label class="radio-label">
                            <b-form-radio v-model="detailInfo" value="persen">Persen</b-form-radio>
                        </label>
                        <b-input-group append="%">
                            <b-form-input v-model="input.nominalPersen" :id="`persenKondisiDesc-${kondisi.index}`"
                                name="kondisiNominalPersen" step="0.01" type="number" @blur="roundPersen"
                                :disabled="detailInfo == 'nominal'" required></b-form-input>
                            <b-popover :target="`persenKondisiDesc-${kondisi.index}`" title="Catatan" triggers="focus">
                                <ul class="tooltip-content-wrapper list-popover-wrapper">
                                    <li class="mb-2">
                                        <span class="small-muted-persen">100%</span> -> harga dasar (tidak ada penambahan
                                        maupun
                                        pengurangan)
                                    </li>
                                    <li class="mb-2">
                                        <span class="small-muted-persen">110%</span> -> Tambahan 10% dari harga barang
                                    </li>
                                    <li class="mb-0">
                                        <span class="small-muted-persen">80%</span> -> Potongan 20% dari harga barang
                                    </li>
                                </ul>
                            </b-popover>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group>
                        <label class="radio-label">
                            <b-form-radio v-model="detailInfo" value="nominal">Nominal</b-form-radio>
                        </label>
                        <b-input-group prepend="Rp.">
                            <b-form-input v-model="input.nominalAngka" @input="nominalAngka" name="kondisiNominalAngka"
                                :disabled="detailInfo == 'persen'" required></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <label>Harga Maksimal</label>
            <b-input-group prepend="Rp.">
                <b-form-input v-model="input.hargaMaksimal" name="hargaMaksimal" required></b-form-input>
            </b-input-group>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="closeEditHargaBtn" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="updateHargaBtn" type="button" :disabled="isBusy" @click="onSubmitKondisi()"
                    form="updateHargaForm">
                    {{ isBusy ? 'Loading...' : 'Kirim' }}
                </b-button>
            </template>
        </b-modal>

        <b-modal id="edit-kondisi" size="md" title="Ubah Kondisi">
            <label>Nama</label>
            <b-input-group class="mb-3">
                <b-form-input v-model="input.name" name="harga" required></b-form-input>
            </b-input-group>

           
            <b-form-group v-if="merkBarang && merkBarang.jenis.id != 13 && merkBarang && merkBarang.jenis.id != 14" label="Packing">
                <b-form-select v-model="input.dus" name="kondisiPacking" :options="kondisiOption" value-field="value"
                    text-field="name" required>
                </b-form-select>
            </b-form-group>
            <b-form-group v-else label="BPKB">
                <b-form-select v-model="input.namaSendiri" name="kondisiKendaraan" :options="kondisiKendaraan"
                    value-field="value" text-field="name" required>
                </b-form-select>
            </b-form-group>

            <b-row>
                <b-col md="4">
                    <b-form-group>
                        <label class="radio-label">
                            <b-form-radio v-model="detailInfo" value="persen">Persen</b-form-radio>
                        </label>
                        <b-input-group append="%">
                            <b-form-input v-model="input.nominalPersen" :id="`persenKondisiDesc-${kondisi.index}`"
                                name="kondisiNominalPersen" step="0.01" type="number" @blur="roundPersen"
                                :disabled="detailInfo == 'nominal'" required></b-form-input>
                            <b-popover :target="`persenKondisiDesc-${kondisi.index}`" title="Catatan" triggers="focus">
                                <ul class="tooltip-content-wrapper list-popover-wrapper">
                                    <li class="mb-2">
                                        <span class="small-muted-persen">100%</span> -> harga dasar (tidak ada penambahan
                                        maupun
                                        pengurangan)
                                    </li>
                                    <li class="mb-2">
                                        <span class="small-muted-persen">110%</span> -> Tambahan 10% dari harga barang
                                    </li>
                                    <li class="mb-0">
                                        <span class="small-muted-persen">80%</span> -> Potongan 20% dari harga barang
                                    </li>
                                </ul>
                            </b-popover>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group>
                        <label class="radio-label">
                            <b-form-radio v-model="detailInfo" value="nominal">Nominal</b-form-radio>
                        </label>
                        <b-input-group prepend="Rp.">
                            <b-form-input v-model="input.nominalAngka" @input="nominalAngka" name="kondisiNominalAngka"
                                :disabled="detailInfo == 'persen'" required></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <label>Harga Maksimal</label>
            <b-input-group prepend="Rp.">
                <b-form-input v-model="input.hargaMaksimal" name="hargaMaksimal" required></b-form-input>
            </b-input-group>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="closeEditHargaBtn" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="updateHargaBtn" type="button" :disabled="isBusy" @click="onEditKondisi()"
                    form="updateHargaForm">
                   {{ isBusy ? 'Loading...' : 'Kirim' }}
                </b-button>
            </template>
        </b-modal>

        <ModalConfirm id="confirm-hapus-kondisi" title="Konfirmasi hapus Kondisi" :isSubmitting="isBusy"
            desc="Apakah anda yakin untuk menghapus kondisi ini?" @submit="onDeleteKondisi()" />

        <b-modal id="kondisiMerk" size="lg" title="Kondisi Merk">
            <b-table bordered hover :fields="fields" :busy="isBusy" :items="kondisiMerk" responsive show-empty>
                <template v-slot:empty>
                    Tidak ada data kondisi dari merk yang terpilih atau merk belum dipilih
                </template>
                <template v-slot:cell(klasifikasi)="row">
                    <div v-if="row.item.dus !== null">
                        <span v-if="row.item.dus">Dus</span>
                        <span v-else>Non Dus</span>
                    </div>
                    <div v-else>
                        <span v-if="row.item.namaSendiri">BPKB a/n Sendiri</span>
                        <span v-else>BPKB a/n Orang Lain</span>
                    </div>
                </template>
                <template v-slot:cell(hargaMaksimal)="row">
                    <div class="text-right no wrap" v-if="row.item.hargaMaksimal == null">
                        {{ $helper.addThousandSeparator(row.item.hargaMaksimal) }} </div>
                    <div class="text-right no wrap text-danger" v-else-if="row.item.hargaMaksimal < 0">Rp.
                        {{ $helper.addThousandSeparator(row.item.hargaMaksimal) }} </div>
                    <div class="text-right no wrap" v-else>Rp.
                        {{ $helper.addThousandSeparator(row.item.hargaMaksimal) }} </div>
                </template>
                <template v-slot:cell(nominalAngka)="row">
                    <div class="text-right no wrap" v-if="row.item.nominalAngka == null">
                        {{ $helper.addThousandSeparator(row.item.nominalAngka) }} </div>
                    <div class="text-right no wrap text-danger" v-else-if="row.item.nominalAngka < 0">Rp.
                        {{ $helper.addThousandSeparator(row.item.nominalAngka) }} </div>
                    <div class="text-right no wrap" v-else>Rp.
                        {{ $helper.addThousandSeparator(row.item.nominalAngka) }} </div>
                </template>
                <template v-slot:cell(nominalPersen)="row">
                    <div class="text-right no-wrap" v-if="row.item.nominalPersen == null">
                        {{ $helper.addThousandSeparator(row.item.nominalPersen) }} </div>
                    <div class="text-right no-wrap text-danger" v-else-if="row.item.nominalPersen < 100">
                        {{ $helper.addThousandSeparator(row.item.nominalPersen) }} %</div>
                    <div class="text-right no-wrap" v-else>{{ $helper.addThousandSeparator(row.item.nominalPersen)
                    }}
                        %</div>
                </template>
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Loading data...</strong>
                    </div>
                </template>
            </b-table>

            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="closeEditHargaBtn" @click="cancel()">
                    Cancel
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
export default {
    props: {
        rincian: {
            type: Object,
            required: true
        },
        idMerk: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            id: null,
            initStatus: 0,
            isSubmitting: false,
            isBusy: true,

            input: {
                kondisi: [],
                name: null,
                dus: null,
                namaSendiri: null,
                nominalAngka: null,
                nominalPersen: null,
                hargaMaksimal: 0
            },

            activeId: null,

            merkBarang: null,
            kondisiSesuaiMerk: true,
            detailInfo: "persen",
            kondisi: [],
            kondisiMerk: [],

            fields: [
                { key: "name", label: "Grade Barang", sortable: true },
                { key: "klasifikasi", label: "Klasifikasi", sortable: true },
                { key: "hargaMaksimal", label: "Harga Maksimal", sortable: true },
                { key: "nominalAngka", label: "Nominal Angka", sortable: true },
                { key: "nominalPersen", label: "Nominal Persen", sortable: true },
                { key: "keterangan", label: "Keterangan", sortable: true },
                { key: "aksi", label: "Aksi" }
            ],

            kondisiOption: [
                { id: 0, value: true, name: 'Dus' },
                { id: 1, value: false, name: 'Non Dus' },
            ],

            kondisiKendaraan: [
                { value: true, name: 'Nama Sendiri' },
                { value: false, name: 'Nama Orang Lain' }
            ],
        }
    },
    methods: {
        init() {
            this.initStatus = 0
            this.id = (this.idMerk != null) ? this.idMerk : this.$route.params.id

            let getSingleTipeBarang = this.$axios.get(`barang-merk/${this.id}`).then(response => {

                this.merkBarang = response.data
                this.merkBarang.jenis = this.merkBarang.barangJenis
                if (this.merkBarang.kondisi.length != 0) {
                    let idx, nameMerk, ketMerk, namaSendiriMerk, dusMerk, detailInfoMerk, nominalPMerk, nominalAMerk, hargaMaksimalMerk = null
                    this.kondisiSesuaiMerk = false

                    for (var x of this.merkBarang.kondisi) {
                        nameMerk = x.name
                        ketMerk = x.keterangan
                        hargaMaksimalMerk = this.$helper.addThousandSeparator(x.hargaMaksimal)
                        let nominalPMerk, nominalAMerk = null

                        if (x.dus == null) {
                            if (x.namaSendiri == true) namaSendiriMerk = 0
                            else namaSendiriMerk = 1
                        }
                        else {
                            if (x.dus == true) dusMerk = 0
                            else dusMerk = 1
                        }

                        if (x.nominalAngka == null) {
                            detailInfoMerk = "persen",
                                nominalPMerk = x.nominalPersen
                        }
                        else {
                            detailInfoMerk = "nominal",
                                nominalAMerk = this.$helper.addThousandSeparator(x.nominalAngka)
                        }

                        if (dusMerk == null) dusMerk = 0
                        if (namaSendiriMerk == null) namaSendiriMerk = 0

                        // let url = []
                        // for(var file of x.suratEdaran){
                        //         url.push({
                        //         id: file.id,
                        //         url:file.filepath,
                        //     })
                        // }

                        this.kondisi.push({
                            index: this.indexKondisi,
                            id: x.id,
                            name: nameMerk,
                            keterangan: ketMerk,
                            dus: x.dus,
                            namaSendiri: x.namaSendiri,
                            detailInfo: detailInfoMerk,
                            nominalPersen: nominalPMerk,
                            nominalAngka: nominalAMerk,
                            hargaMaksimal: hargaMaksimalMerk,
                            filePDF: [],
                        })
                        this.indexKondisi++
                    }
                }
            })

            let getKondisiMerk = this.$axios.get(`barang-merk/kondisi/${this.rincian.id}`).then(response => {
                this.kondisiMerk = response.data
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
            Promise.all([getSingleTipeBarang, getKondisiMerk]).then(() => {
                this.toggleBusy()
                this.initStatus = 1
            })
                .catch(error => {
                    console.log(error)
                    this.initStatus = -1
                })

        },
        fetchData() {
            this.toggleBusy()
            this.$axios.get(`barang-merk/${this.id}`).then(response => {
                this.kondisi = []
                this.kondisiMerk = []
                this.merkBarang = response.data
                this.merkBarang.jenis = this.merkBarang.barangJenis
                if (this.merkBarang.kondisi.length != 0) {
                    let idx, nameMerk, ketMerk, namaSendiriMerk, dusMerk, detailInfoMerk, nominalPMerk, nominalAMerk, hargaMaksimalMerk = null
                    this.kondisiSesuaiMerk = false

                    for (var x of this.merkBarang.kondisi) {
                        nameMerk = x.name
                        ketMerk = x.keterangan
                        hargaMaksimalMerk = this.$helper.addThousandSeparator(x.hargaMaksimal)
                        let nominalPMerk, nominalAMerk = null

                        if (x.dus == null) {
                            if (x.namaSendiri == true) namaSendiriMerk = 0
                            else namaSendiriMerk = 1
                        }
                        else {
                            if (x.dus == true) dusMerk = 0
                            else dusMerk = 1
                        }

                        if (x.nominalAngka == null) {
                            detailInfoMerk = "persen",
                                nominalPMerk = x.nominalPersen
                        }
                        else {
                            detailInfoMerk = "nominal",
                                nominalAMerk = this.$helper.addThousandSeparator(x.nominalAngka)
                        }

                        if (dusMerk == null) dusMerk = 0
                        if (namaSendiriMerk == null) namaSendiriMerk = 0

                        // let url = []
                        // for(var file of x.suratEdaran){
                        //         url.push({
                        //         id: file.id,
                        //         url:file.filepath,
                        //     })
                        // }

                        this.kondisi.push({
                            index: this.indexKondisi,
                            id: x.id,
                            name: nameMerk,
                            keterangan: ketMerk,
                            dus: x.dus,
                            namaSendiri: x.namaSendiri,
                            detailInfo: detailInfoMerk,
                            nominalPersen: nominalPMerk,
                            nominalAngka: nominalAMerk,
                            hargaMaksimal: hargaMaksimalMerk,
                            filePDF: [],
                        })
                        this.indexKondisi++
                    }
                }
                this.toggleBusy()
            }).catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },


        addKondisi() {
            this.input = {
                name: null,
                dus: null,
                namaSendiri: null,
                nominalAngka: null,
                nominalPersen: null,
                hargaMaksimal: 0
            }

            this.$bvModal.show("modal-entri-kondisi")

        },

        onSubmitKondisi() {
            if (this.$helper.isNullOrEmpty(this.input.name)) {
                return this.$helper.toastErr(this, "Mohon isi Nama!")
            }
            if (this.input.namaSendiri == null && this.merkBarang.jenis.id == 13 || this.input.namaSendiri == null && this.merkBarang.jenis.id == 14) {
                return this.$helper.toastErr(this, "Mohon Lengkapi Data !")
            }

            if (this.input.dus == null && this.merkBarang.jenis.id != 13 && this.merkBarang.jenis.id != 14) {
                return this.$helper.toastErr(this, "Mohon Lengkapi Data!")
            }

            this.isBusy = true
            let json = {
                "merkBarangId": this.id,
                "name": this.input.name,
                "dus": (this.merkBarang.jenis.id != 13 && this.merkBarang.jenis.id != 14) ? this.input.dus : null ,
                "namaSendiri": (this.merkBarang.jenis.id == 13 || this.merkBarang.jenis.id == 14) ? this.input.namaSendiri : null, // true/false apabila kendaraan, null bila elek/emas
                "nominalAngka": (this.detailInfo == 'persen') ? null : this.$helper.removeThousandSeparator(this.input.nominalAngka), // bisa null bila menggunakan persen
                "nominalPersen": (this.detailInfo == 'nominal') ? null : this.input.nominalPersen, // bisa null bila menggunakan angka
                "hargaMaksimal": this.$helper.removeThousandSeparator(this.input.hargaMaksimal)
            }


            this.$axios.post(`barang-merk/insert-update-condition`, json).then(response => {

                this.$bvModal.hide("modal-entri-kondisi")
                this.$helper.toastSucc(this, 'Data berhasil ditambahkan')
                this.isBusy = false
                this.fetchData()
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
        },


        editKondisi(item) {
            this.activeId = item.id
            this.input.name = item.name
            this.input.dus = item.dus
            this.input.namaSendiri = item.namaSendiri
            this.input.nominalAngka = item.nominalAngka
            this.input.nominalPersen = item.nominalPersen
            this.input.hargaMaksimal = item.hargaMaksimal

            this.$bvModal.show("edit-kondisi")
        },

        onEditKondisi() {
            if (this.$helper.isNullOrEmpty(this.input.name)) {
                return this.$helper.toastErr(this, "Mohon isi Nama!")
            }
            if (this.input.namaSendiri == null && this.merkBarang.jenis.id == 13 || this.input.namaSendiri == null && this.merkBarang.jenis.id == 14) {
                return this.$helper.toastErr(this, "Mohon Lengkapi Data !")
            }

            if (this.input.dus == null && this.merkBarang.jenis.id != 13 && this.merkBarang.jenis.id != 14) {
                return this.$helper.toastErr(this, "Mohon Lengkapi Data!")
            }

            this.isBusy = true
            let json = {
                "id": this.activeId,
                "merkBarangId": this.id,
                "name": this.input.name,
                "dus": (this.merkBarang.jenis.id != 13 && this.merkBarang.jenis.id != 14) ? this.input.dus : null ,
                "namaSendiri": (this.merkBarang.jenis.id == 13 || this.merkBarang.jenis.id == 14) ? this.input.namaSendiri : null, // true/false apabila kendaraan, null bila elek/emas
                "nominalAngka": (this.detailInfo == 'persen') ? null : this.$helper.removeThousandSeparator(this.input.nominalAngka), // bisa null bila menggunakan persen
                "nominalPersen": (this.detailInfo == 'nominal') ? null : this.input.nominalPersen, // bisa null bila menggunakan angka
                "hargaMaksimal": this.$helper.removeThousandSeparator(this.input.hargaMaksimal)
            }


            this.$axios.post(`barang-merk/insert-update-condition`, json).then(response => {

                this.$bvModal.hide("edit-kondisi")
                this.$helper.toastSucc(this, 'Data berhasil diubah')
                this.isBusy = false
                this.fetchData()
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.isBusy = false
                })
        },


        confirmDeleteKondisi(id) {
            this.activeId = id
            this.$bvModal.show("confirm-hapus-kondisi")
        },
        onDeleteKondisi() {
            this.isBusy = true
            this.$axios.post(`barang-merk/delete-condition?kondisiId=` + this.activeId).then(response => {

                this.isBusy = false
                this.$bvModal.hide("confirm-hapus-kondisi")
                this.$helper.toastSucc(this, 'Data berhasil dihapus')
                this.fetchData()
            })
                .catch(error => {
                    this.isBusy = false
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
        },
        roundPersen() {
            var x = Number(this.input.nominalPersen).toFixed(2);
            this.input.nominalPersen = x;
        },
        nominalAngka() {
            if (this.input.nominalAngka > 0) {
                this.input.nominalAngka = 0
                this.$helper.toastErr(this, "nominal angka harus minus")
            }
        },
        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },
    },
    watch: {
        "input.nominalAngka": function (newValue) {
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.nominalAngka = result);
        },
        "input.hargaMaksimal": function (newValue) {
            if (newValue != "") {
                let cleanValue = this.$helper.changeToValue(newValue);
                const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".").replace(/^0+/, "");
                this.$nextTick(() => this.input.hargaMaksimal = result);
            } else {
                this.$nextTick(() => this.input.hargaMaksimal = 0);
            }
        },

        "input.nominalPersen": function (newValue) {
            if (newValue > 100) {
                this.input.nominalPersen = 0
                this.$helper.toastErr(this, "nominal persen tidak boleh diatas 100")
            }
        },
    },
    created() {
        this.init()
    }
}
</script>